import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEmployeesStore } from "../store";

export const EmployeeModalSteps = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const addEmployeeFormActiveStep = useEmployeesStore(
    state => state.addEmployeeFormActiveStep
  );
  const scrollContainerRef = useRef(null);
  const activeTabRef = useRef(null);

  const { t } = useTranslation();

  const steps = [
    { name: t("HR.AddEmployee.EmployerInformation"), step: 1 },
    { name: t("HR.AddEmployee.PersonalInfo"), step: 2 },
    { name: t("HR.AddEmployee.FamilyInformation"), step: 3 },
    { name: t("HR.AddEmployee.EducationBackground"), step: 4 },
    { name: t("HR.AddEmployee.Job"), step: 5 },
    { name: t("HR.AddEmployee.BankandTIN"), step: 6 },
    { name: t("HR.AddEmployee.EmergencyContact"), step: 7 }
  ];

  useEffect(() => {
    if (activeTabRef.current && scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const activeTab = activeTabRef.current;

      // Calculate position to center the active tab
      const containerWidth = container.clientWidth;
      const tabWidth = activeTab.clientWidth;
      const tabLeft = activeTab.offsetLeft;

      // Scroll the tab into view with smooth behavior
      container.scrollTo({
        left: tabLeft - containerWidth / 2 + tabWidth / 2,
        behavior: "smooth"
      });
    }
  }, [addEmployeeFormActiveStep]);

  return (
    <Box
      ref={scrollContainerRef}
      sx={{
        overflowX: "auto",
        width: "100%",
        "&::-webkit-scrollbar": {
          display: "none"
        }
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          minWidth: isMobile ? "max-content" : "auto",
          pb: 1
        }}
      >
        {steps.map(step => (
          <Stack
            key={step.name}
            ref={addEmployeeFormActiveStep === step.step ? activeTabRef : null}
            alignItems="center"
            justifyContent="center"
            sx={{
              fontWeight: addEmployeeFormActiveStep === step.step ? 700 : 400,
              bgcolor:
                addEmployeeFormActiveStep === step.step
                  ? "primary.main"
                  : "neutral.main",
              color:
                addEmployeeFormActiveStep === step.step
                  ? "primary.contrastText"
                  : "neutral.contrastText",
              py: 1,
              px: isMobile ? 2 : 4,
              borderRadius: 1,
              fontSize: isMobile ? "12px" : "14px",
              whiteSpace: "nowrap",
              minWidth: isMobile ? "auto" : undefined
            }}
          >
            {step.name}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
